class HeroBanner {
  constructor(sectionId, options) {
    this.sectionId = sectionId;
    this.options = Object.assign({ autoplay: true, autoplaySpeed: 5000, pauseOnHover: true }, options);
    this.slider = document.getElementById(`hero-slider-${sectionId}`);
    if (!this.slider) return;

    this.slides = Array.from(this.slider.querySelectorAll('.hero-slide'));
    this.dotsWrapper = document.getElementById(`hero-dots-${sectionId}`);
    this.dots = this.dotsWrapper ? Array.from(this.dotsWrapper.querySelectorAll('.hero-dot')) : [];
    this.section = this.slider.closest('.hero-banner');
    this.prevBtn = this.section ? this.section.querySelector('[data-hero-prev]') : null;
    this.nextBtn = this.section ? this.section.querySelector('[data-hero-next]') : null;

    this.currentIndex = 0;
    this.timer = null;
    this.cleanupTimer = null;

    if (this.slides.length <= 1) return;

    this.bindEvents();
    if (this.options.autoplay) this.startAutoplay();
  }

  bindEvents() {
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goToSlide(index);
        this.restartAutoplay();
      });
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goToSlide(this.currentIndex - 1);
        this.restartAutoplay();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goToSlide(this.currentIndex + 1);
        this.restartAutoplay();
      });
    }

    if (this.section && this.options.pauseOnHover) {
      this.section.addEventListener('mouseenter', () => this.stopAutoplay());
      this.section.addEventListener('mouseleave', () => {
        if (this.options.autoplay) this.startAutoplay();
      });
    }
  }

  goToSlide(index) {
    const total = this.slides.length;
    const previousIndex = this.currentIndex;
    this.currentIndex = ((index % total) + total) % total;

    if (previousIndex !== this.currentIndex) {
      // Mark the outgoing slide so the "slide" transition can animate it off-screen
      // in the correct direction, then clean up the marker after the animation.
      const outgoingSlide = this.slides[previousIndex];
      if (outgoingSlide) {
        outgoingSlide.classList.add('is-prev');
        if (this.cleanupTimer) clearTimeout(this.cleanupTimer);
        this.cleanupTimer = setTimeout(() => {
          outgoingSlide.classList.remove('is-prev');
        }, 700);
      }
    }

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.currentIndex);
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.currentIndex);
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => {
      this.goToSlide(this.currentIndex + 1);
    }, this.options.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    if (this.options.autoplay) this.startAutoplay();
  }
}

window.HeroBanner = HeroBanner;
